"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMediabaseEssenceProperty = exports.mediabaseEssencePropertyDefinition = void 0;
exports.mediabaseEssencePropertyDefinition = {
    view: {
        label: 'Mediabase essence',
        style: 'video-essence',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: ['Media Partnerships Video', 'RBMN Video'],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'mediabase-essence',
};
const isMediabaseEssenceProperty = (prop) => {
    return prop.name === exports.mediabaseEssencePropertyDefinition.name;
};
exports.isMediabaseEssenceProperty = isMediabaseEssenceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVkaWFiYXNlLWVzc2VuY2UucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9tZWRpYWJhc2UtZXNzZW5jZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxtQkFBbUI7UUFDMUIsS0FBSyxFQUFFLGVBQWU7S0FDdkI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxDQUFDLDBCQUEwQixFQUFFLFlBQVksQ0FBQztTQUNyRDtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxtQkFBbUI7Q0FDTSxDQUFBO0FBSTFCLE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxJQUFrQixFQUFvQyxFQUFFO0lBQ2pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywwQ0FBa0MsQ0FBQyxJQUFJLENBQUE7QUFDOUQsQ0FBQyxDQUFBO0FBRlksUUFBQSwwQkFBMEIsOEJBRXRDIn0=